import { CountryItem } from '../types';

import cn from '../styles.module.css';

const formatCountriesList = (list: CountryItem[]): CountryItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {};

    if (!result.active) {
      render.name = <div className={cn.disabledField}>{result.name}</div>;
      render.alpha3 = <div className={cn.disabledField}>{result.alpha3}</div>;
      render.alpha2 = <div className={cn.disabledField}>{result.alpha2}</div>;
      render.numeric = <div className={cn.disabledField}>{result.numeric}</div>;
      render.riskScore = (
        <div className={cn.disabledField}>{result.riskScore}</div>
      );
      render.active = <div className={cn.disabledField}>Disabled</div>;
    } else {
      render.active = <div>Active</div>;
    }

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatCountriesList;
